// Shtrix kodni yorliqqa moslash: format va chiziq qalinligini avtomatik tanlaydi.
//
// Asosiy muammo: 30 mm yorliqqa 13 xonali kodni CODE128 da chizsak, eng ingichka
// chiziq 0.21 mm chiqadi. Skanerlar uchun amaliy minimum ~0.25 mm (termal printer
// bo'yog'i yoyilib, ingichka oq oraliqlarni yopib qo'yadi). Bir xil kod EAN-13 da
// atigi 115 modul egallaydi (CODE128 da 143), ya'ni chiziqlar ~25% qalinroq.
// Shuning uchun haqiqiy EAN-13/EAN-8 kodlari o'z formatida chiziladi.

// CSS spetsifikatsiyasi: 1in = 96px = 25.4mm. Bu nisbat ekranda ham, chop etishda
// ham o'zgarmaydi -- shuning uchun mm <-> px o'girish aniq (yaxlitlash yo'qotishisiz).
export const PX_PER_MM = 96 / 25.4

// Skaner ishonchli o'qiy oladigan eng ingichka chiziq (X-dimension).
export const MIN_MODULE_MM = 0.25

export function mmToPx(mm) {
	return mm * PX_PER_MM
}

export function pxToMm(px) {
	return px / PX_PER_MM
}

// Shtrix-kodni tozalash. Backend uni ba'zan bo'sh joy bilan qaytaradi (masalan
// "4870254132743        "). Bo'sh joy shtrix-kodda hech qachon ma'noli emas, lekin
// tozalanmasa /^\d{13}$/ kabi tekshiruvlar yiqiladi va haqiqiy EAN-13 o'rniga
// CODE128 chizilib qoladi. Format/o'lcham aniqlaydigan hamma funksiya shuni ishlatadi.
export function cleanBarcode(value) {
	return String(value ?? '').trim()
}

// CODE128: start (11) + har bir belgi (11) + nazorat yig'indisi (11) + stop (13).
// Raqamlar CODE C da juftlab kodlanadi; toq bo'lsa birinchi raqam CODE B da qoladi
// va C ga o'tish belgisi qo'shiladi.
export function countCode128Modules(value) {
	const text = cleanBarcode(value)
	if (!text) return 0
	const packedAsPairs = /^\d+$/.test(text) && text.length > 1
	const symbols = packedAsPairs
		? (text.length % 2 === 0 ? text.length / 2 : 2 + (text.length - 1) / 2)
		: text.length
	return 11 + symbols * 11 + 11 + 13
}

// EAN/UPC oilasining nazorat raqami: belgilar navbatma-navbat firstWeight va
// (4 - firstWeight) ga ko'paytiriladi. EAN-13 da 1/3, EAN-8 da 3/1.
export function hasValidCheckDigit(value, firstWeight) {
	const text = cleanBarcode(value)
	let sum = 0
	for (let i = 0; i < text.length - 1; i++) {
		sum += Number(text[i]) * (i % 2 === 0 ? firstWeight : 4 - firstWeight)
	}
	return (10 - (sum % 10)) % 10 === Number(text[text.length - 1])
}

// Faqat formatni tanlaydi (chiziq qalinligini o'zgartirmaydi). Barcha yorliqlarda
// bir xil simvolikadan foydalanish uchun: haqiqiy EAN-13/EAN-8 -> o'z formati,
// aks holda CODE128. lastChar EAN13 uchun o'ng quiet zone belgisi.
export function barcodeFormat(value) {
	const text = cleanBarcode(value)
	if (/^\d{13}$/.test(text) && hasValidCheckDigit(text, 1)) {
		return { format: 'EAN13', lastChar: '>' }
	}
	if (/^\d{8}$/.test(text) && hasValidCheckDigit(text, 3)) {
		return { format: 'EAN8' }
	}
	return { format: 'CODE128' }
}

// Foydalanuvchi tanlashi mumkin bo'lgan formatlar (Sozlamalar ro'yxati uchun).
// 'auto' -- kodga qarab EAN-13/EAN-8/CODE128. Qolganlari -- aniq format.
export const BARCODE_MODES = [
	'auto',
	'CODE128',
	'CODE39',
	'EAN13',
	'EAN8',
	'UPC',
	'ITF',
	'ITF14',
	'codabar',
	'MSI',
	'pharmacode',
]

// Tanlangan format shu kodga to'g'ri keladimi? Kelmasa chaqiruvchi CODE128 ga
// qaytadi -- bo'sh (chizilmagan) shtrix-kod chiqmasligi uchun. Diqqat: EAN/UPC
// da nazorat raqami noto'g'ri bo'lsa jsbarcode hech narsa chizmaydi, shuning
// uchun to'liq uzunlikda nazorat raqami ham tekshiriladi (qisqa uzunlikda
// jsbarcode o'zi hisoblab qo'shadi).
export function isValidForFormat(value, format) {
	const t = cleanBarcode(value)
	if (!t) return false
	switch (format) {
		case 'EAN13': return (/^\d{13}$/.test(t) && hasValidCheckDigit(t, 1)) || /^\d{12}$/.test(t)
		case 'EAN8': return (/^\d{8}$/.test(t) && hasValidCheckDigit(t, 3)) || /^\d{7}$/.test(t)
		case 'UPC': return (/^\d{12}$/.test(t) && hasValidCheckDigit(t, 3)) || /^\d{11}$/.test(t)
		case 'ITF14': return (/^\d{14}$/.test(t) && hasValidCheckDigit(t, 3)) || /^\d{13}$/.test(t)
		case 'ITF': return /^\d+$/.test(t) && t.length % 2 === 0
		case 'MSI': return /^\d+$/.test(t)
		case 'pharmacode': { const n = Number(t); return /^\d+$/.test(t) && n >= 3 && n <= 131070 }
		case 'codabar': return /^[A-Da-d]?[0-9\-$:/.+]+[A-Da-d]?$/.test(t)
		case 'CODE39': return /^[0-9A-Z\-. $/+%]+$/.test(t)
		case 'CODE128': default: return true
	}
}

// Format uchun modul sonini (quiet zone bilan) YUQORIDAN baholaydi. resolveBarcode
// moduleWidth ni pastga yaxlitlagani uchun bu -- kod hech qachon qutidan chiqmaydi
// (kesilmaydi), faqat biroz kichrayishi mumkin (xavfsiz tomon).
export function estimateModules(value, format) {
	const len = cleanBarcode(value).length
	switch (format) {
		case 'EAN13':
		case 'UPC': return 117
		case 'EAN8': return 83
		case 'ITF14': return 135
		case 'CODE39': return (len + 2) * 16 + 20
		case 'ITF': return len * 10 + 20
		case 'codabar': return (len + 2) * 12 + 20
		case 'MSI': return len * 13 + 20
		case 'pharmacode': return 130
		case 'CODE128': default: return countCode128Modules(value) + 20
	}
}

// Tanlangan rejim (Sozlamalardagi) va kod uchun react-barcode formatini beradi.
// 'auto' -> barcodeFormat; aniq format -> agar kodga to'g'ri kelsa o'sha, aks
// holda CODE128 (bo'sh chiqmasin).
export function barcodeForMode(value, mode) {
	if (!mode || mode === 'auto') return barcodeFormat(value)
	if (mode === 'code128' || mode === 'CODE128') return { format: 'CODE128' }
	if (isValidForFormat(value, mode)) {
		return mode === 'EAN13' ? { format: 'EAN13', lastChar: '>' } : { format: mode }
	}
	return { format: 'CODE128' }
}

// Berilgan kod va yorliqdagi joy (mm) uchun react-barcode proplarini qaytaradi.
//
// Diqqat: jsbarcode 12 xonali kodni ham "EAN13" deb qabul qilib, o'zi nazorat
// raqami qo'shib qo'yadi -- u holda skaner bazadagidan boshqa kod qaytaradi.
// Shuning uchun uzunlik va nazorat raqami qat'iy tekshiriladi.
export function resolveBarcode(value, widthMm, options = {}) {
	const text = cleanBarcode(value)
	if (!text || !(widthMm > 0)) return null

	// code128Only: foydalanuvchi "hammasi bir xil (CODE128)" ni tanlaganda --
	// haqiqiy EAN bo'lsa ham CODE128 da chiziladi.
	const code128Only = !!options.code128Only
	// forced: foydalanuvchi aniq format tanlaganda (CODE39, ITF, ...). Kodga
	// to'g'ri kelmasa CODE128 ga qaytadi (bo'sh chiqmasin).
	const forced = options.format && options.format !== 'auto' ? options.format : null

	let format = 'CODE128'
	let extra = {}
	// Chiziqlar egallaydigan modullar + har ikki chetdagi bo'sh oq joy ("quiet
	// zone"). Quiet zone bo'lmasa skaner kodning boshi/oxirini topa olmaydi.
	let totalModules

	if (forced) {
		format = isValidForFormat(text, forced) ? forced : 'CODE128'
		if (format === 'EAN13') extra = { lastChar: '>' }
		totalModules = estimateModules(text, format)
	} else if (!code128Only && /^\d{13}$/.test(text) && hasValidCheckDigit(text, 1)) {
		format = 'EAN13'
		// lastChar ">" -- standart o'ng quiet zone belgisi.
		extra = { lastChar: '>' }
		// 115 = 12 (chapdagi raqam) + 95 (chiziqlar) + 8 (lastChar). Quiet zone shu
		// 12 va 8 modul ichida. +2 -- jsbarcode bo'laklarni yaxlitlashiga zaxira.
		totalModules = 115 + 2
	} else if (!code128Only && /^\d{8}$/.test(text) && hasValidCheckDigit(text, 3)) {
		format = 'EAN8'
		// 67 modul chiziq + har ikki chetda 8 modul quiet zone.
		totalModules = 67 + 16
	} else {
		const bars = countCode128Modules(text)
		if (!bars) return null
		// CODE128 uchun har ikki chetda 10 modul quiet zone.
		totalModules = bars + 20
	}

	// Chiziq qalinligi (px). Pastga yaxlitlanadi -- kod hech qachon qutidan chiqmasin.
	const moduleWidthPx = Math.floor(mmToPx(widthMm) / totalModules * 100) / 100
	const moduleMm = pxToMm(moduleWidthPx)

	return {
		format,
		...extra,
		width: moduleWidthPx,
		moduleMm,
		totalModules,
		// Skaner ishonchli o'qiy oladimi -- konstruktorda ogohlantirish uchun.
		scannable: moduleMm >= MIN_MODULE_MM,
	}
}
